import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

export interface NewsItem {
  id: string;
  title: string;
  content: string;
  link: string;
  dateCreated: string;
  expires: string;
  isNew: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  private apiService = inject(ApiService);

  getNews(): Observable<NewsItem[]> {
    return this.apiService.get('api/news');
  }
}
